import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconFormIndicatorLocked(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19.778 2H4.222C3 2 2 3 2 4.222v15.556C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778V4.222C22 3 21 2 19.778 2Z"
        fill="#9D9DB1"
      />
      <path
        d="M15.75 9.333h-.625V8.095C15.125 6.387 13.725 5 12 5S8.875 6.387 8.875 8.095v1.238H8.25c-.688 0-1.25.557-1.25 1.238v6.19C7 17.444 7.563 18 8.25 18h7.5c.688 0 1.25-.557 1.25-1.238v-6.19c0-.682-.563-1.239-1.25-1.239ZM12 14.905c-.688 0-1.25-.557-1.25-1.238 0-.681.563-1.238 1.25-1.238.688 0 1.25.557 1.25 1.238 0 .68-.563 1.238-1.25 1.238Zm1.938-5.572h-3.876V8.095A1.93 1.93 0 0 1 12 6.176a1.93 1.93 0 0 1 1.938 1.92v1.237Z"
        fill="#fff"
      />
    </BaseIcon>
  );
}
